import axios from "axios"
import { orders } from "../../../../../../config/api"
import { Dispatch } from "redux"
import { ActionType } from "./ActionTypes"

function fetchOrders() {
    return axios.get(orders)
}

export const actionFetchOrders = () => {

    return (dispatch: Dispatch) => {
        dispatch({ type: ActionType.ORDER_LOADING })
        fetchOrders().then((res) => {
            dispatch({ type: ActionType.ORDER_DATA, list: res.data.data })
        }).catch(err => {
            if (err.code === 'ERR_NETWORK') {
                dispatch({ type: ActionType.ORDER_ERROR, message: 'ERR_NETWORK' })
            } else {
                dispatch({ type: ActionType.ORDER_ERROR, message: err.response.data.error })
            }
        })
    }
}
